import * as React from 'react';
import { reduxForm } from 'redux-form';
import { AgreementPageWithFormProps } from '../ClientAgreement';
import ContentContainer, { formSelector } from '../ContentContainer/Content';
import { connect } from 'react-redux';
import agreementStyles from '../ClientAgreement.module.css';

const AgreementPage11 = (props: AgreementPageWithFormProps) => (
  <ContentContainer {...props} requiredSignatures="clientOnly" currentPage={11}>
    <div className={agreementStyles.contentHeader}>
      Exhibit 5<br />
      Other Important Disclosures
      <br />
      <br />
    </div>
    In order for Ascend Debt Relief PLLC to best serve you, it’s imperative that you understand and agree
    to the following disclosures about the potential outcomes.
    <br />
    <br />
    <b>YOU UNDERSTAND AND ACKNOWLEDGE:</b>
    <ol>
      <li>
        The goal of the program is to allow Ascend to negotiate mutually agreeable settlement terms between you and your creditors enrolled in the program. Ascend does not make monthly payments to your creditors. No specific results are guaranteed, but Ascend will use best commercially reasonable efforts to negotiate those settlements on your behalf.
      </li>
      <li>
        It takes time to settle the debts. There are numerous factors that can affect the amount of time required to reach a settlement, including, but not limited to, age of debt, creditors willingness to settle and amount of funds available to settle your debts.
      </li>
      <li>
        The savings plan is based on an estimate. Actual savings may vary.
      </li>
      <li>
        The savings from your decreased debt may be considered taxable income. Consult a tax professional for more information about how the program may affect your tax obligations.
      </li>
      <li>
        You voluntarily stopped making payments for certain creditors and may be breaking terms of agreements. There may be negative consequences, including but not limited to: increase in interest rates, increase in account balance, negative credit reporting, and/or commencement of a lawsuit against you by your creditors.
      </li>
      <li>
        You are responsible for saving funds to settle debts that Ascend negotiated on your behalf. You are responsible for all of your funds.
      </li>
      <li>
        Ascend does not guarantee that we will be able to settle your debts or that the program will save you a specific percentage of your debts.
      </li>
      <li>
        While creditors are generally inclined to work with us to settle your debts, they are not under any obligation to do so.  If a creditor is unwilling to work with us to settle your debts, we will notify you.
      </li>
      <li>While you are enrolled in Ascend’s program, creditors may continue their collection efforts, including but not limited to, sending your accounts to collection agencies or filing a lawsuit against you. Ascend will continue to attempt to settle the accounts enrolled even if there is a lawsuit. <br />
        <b>ASCEND DOES NOT OFFER LEGAL SERVICES AND CANNOT REPRESENT YOU IN A LAWSUIT. IF A LAWSUIT IS FILED AGAINST YOU, YOU MAY NEED TO CONSULT AN ATTORNEY.</b>
      </li>
      <li>
        This Agreement constitutes the entire agreement between you and Ascend, and any prior understandings or representations of any kind preceding the date of this agreement shall not be binding on either party except to the extent incorporated in this Agreement. Ascend may offer different options, but Ascend will not strongly advise that someone terminates payments to creditors, nor will Ascend take any actions that might be construed as interfering with contractual agreements between your creditors and you.
      </li>
    </ol>
  </ContentContainer>
);

const form = reduxForm({
  form: 'clientAgreement',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(AgreementPage11 as any);

export default connect(state => ({
  name: formSelector(state, 'name'),
  existingSignature: formSelector(state, 'clientSignature')
}))(form) as any;
